import { BehaviorSubject } from 'rxjs';

export const hamburgerOffset$ = new BehaviorSubject({});

export const hamburgerOffset = hamburgerOffset$.asObservable();